//
//
//
//
//
//
//
//
import { isMobileView } from './helpers/Functions';
import providerApiService from './services/api/ProviderApiService';
export default {
  data: function data() {
    return {
      visible: true,
      versionNumber: null
    };
  },
  mounted: function mounted() {
    var isMobile = isMobileView();
    this.visible = !isMobile;

    if (this.visible) {
      this.getLatestRelease();
    }
  },
  methods: {
    getLatestRelease: function getLatestRelease() {
      var _this = this;

      providerApiService.latestRelease().then(function (result) {
        if (result.data) {
          _this.versionNumber = result.data.version;
        }
      });
    },
    download: function download() {
      window.open("https://www.topmenumarket.com/storage/download/desktop/top-menu-panel-".concat(this.versionNumber, ".exe"));
    },
    close: function close() {
      this.visible = false;
    }
  }
};